<div class="absolute top-0 bottom-0 left-0 right-0 overflow-hidden pointer-events-none">
  <div #tooltipContent role="tooltip" class="invisible absolute z-100 flex w-[280px] justify-center">
    <div
      class="minw-64 max-w-[280px] flex-col gap-8 rounded-2 bg-secondary-greys-800 p-8 text-secondary-greys-white shadow-tooltip"
      [class.p-8]="activeConfig()"
    >
      @if (activeConfig()?.title) {
        <div class="text-label-md-500">{{ activeConfig()?.title }}</div>
      }
      @if (activeConfig()?.span) {
        <div class="text-body-xs-500"><span [innerHTML]="activeConfig()?.body"></span></div>
      } @else {
        <div class="text-body-xs-400">{{ activeConfig()?.body }}</div>
      }
    </div>
  </div>
</div>
